import { ReactElement } from "react";
import ConfirmTemporaryRequestView from "views/confirm-temporary-request";

const ConfirmTemporaryRequest = (): ReactElement => {
  return <ConfirmTemporaryRequestView />;
};

export default ConfirmTemporaryRequest;
